function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M71,40.216v18.781c0,6.495-2.016,10.38-6,11.59V89c0,1.658-1.342,3-3,3c-1.658,0-3-1.342-3-3V67.997c0-1.658,1.342-3,3-3  c1.406,0,3,0,3-6V40.216c0-3.123-2.347-5.692-5.458-5.975L41,32.325v5.673h9c1.658,0,3,1.343,3,3c0,3.39-2.32,7.364-5.66,9.781  c3.683,3.229,5.584,6.967,5.66,11.165c0.029,1.658-1.289,3.026-2.944,3.056c-0.021,0-0.038,0-0.056,0c-1.632,0-2.971-1.307-3-2.944  c-0.065-3.542-2.511-6.633-7.48-9.448c-1.184-0.672-1.769-2.058-1.421-3.375c0.346-1.317,1.538-2.235,2.9-2.235  c1.755,0,3.574-1.415,4.74-2.999H35v14.999c0,3.308,2.692,6,6,6c1.658,0,3,1.342,3,3V89c0,1.658-1.342,3-3,3c-1.658,0-3-1.342-3-3  V70.616c-5.171-1.333-9-6.038-9-11.619v-15c0-3.308,2.692-5.999,6-5.999v-5.673c0-1.696,0.724-3.321,1.98-4.456  c1.26-1.134,2.93-1.695,4.635-1.512l18.507,1.912C66.31,28.831,71,33.969,71,40.216z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20,50c0,1.657-1.342,3-3,3h-6c-1.658,0-3-1.343-3-3s1.342-3,3-3h6C18.658,47,20,48.343,20,50z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M92,50c0,1.657-1.342,3-3,3h-6c-1.658,0-3-1.343-3-3s1.342-3,3-3h6C90.658,47,92,48.343,92,50z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.363,22.121c1.172,1.172,1.172,3.07,0,4.242c-1.172,1.172-3.07,1.172-4.242,0l-4.242-4.242  c-1.172-1.172-1.172-3.07,0-4.242c1.172-1.172,3.07-1.172,4.242,0L26.363,22.121z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M82.121,22.121l-4.242,4.242c-1.172,1.172-3.07,1.172-4.242,0c-1.172-1.172-1.172-3.07,0-4.242l4.242-4.242  c1.172-1.172,3.07-1.172,4.242,0C83.293,19.051,83.293,20.949,82.121,22.121z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M50,8c1.658,0,3,1.343,3,3v6c0,1.657-1.342,3-3,3c-1.658,0-3-1.343-3-3v-6C47,9.343,48.342,8,50,8z"
});

var SvgFreedom = function SvgFreedom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFreedom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/freedom.97a6211f.svg";
export { ForwardRef as ReactComponent };